class DatatableController {
  constructor($rootScope, datatableService, $interval, $timeout, $window, $scope) {
    'ngInject';
    this.name = 'datatable';
    this.datatableService = datatableService;
    this.$timeout = $timeout;
    this.$scope = $scope;

    var date = new Date();
    date = date.toString();
    var strings;
    var str;

    this.datatableService.getCurrentEvent().then(result => {
      strings = {
        de: {
          page: 'Seite',
          of: 'von',
          header: result.name.de + ' - Teilnehmende Unternehmen',
          companies: 'Unternehmen',
          category: 'Branche',
          date: 'Tag / Uhrzeit',
          room: 'Raum / Referent',
          speaker: 'Referent',
          isin: 'ISIN',
          bbticker: 'Bloomberg-Ticker',
          market_cap: 'Market Cap (in €)',
          index_member: 'Indexzugeh.',
          stock_exchange: 'Börsenplatz',
          footer:
            '* Präsentation in Deutsch',
        },
        en: {
          page: 'Page',
          of: 'of',
          header: result.name.en + '  - Attending Companies',
          companies: 'Companies',
          category: 'Category',
          date: 'Day / Time',
          room: 'Room / Speaker',
          speaker: 'Speaker',
          isin: 'ISIN',
          stock_exchange: 'Stock exchange',
          bbticker: 'Bloomberg-Ticker',
          market_cap: 'Market Cap (in €)',
          index_member: 'Index membership',
          footer: '* Presentation in German',
        },
      }
      if ($rootScope.language === 'de') {
        str = strings.de;
      } else {
        str = strings.en;
      }

      this.gridOptions = {
        // dataSource: {
        //   schema: {
        //     model: {
        //       fields: {
        //         start_time_string: {
        //           type: 'date',
        //           parse: function(e) {
        //             return new Date(e);
        //           },
        //         },
        //       },
        //     },
        //   },
        // },
        filterable: false,
        selectable: false,
        toolbar: ['pdf', 'excel'],
        pdf: {
          allPages: true,
          date: new Date(),
          fileName: 'eigenkapitalforum_' + (new Date(result.start_date).getFullYear()) + '_stand_' + date + '.pdf',
          subject: 'Teilnehmende Unternehmen',
          avoidLinks: true,
          paperSize: 'A4',
          margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '2cm' },
          landscape: false,
          repeatHeaders: true,
          template:
            '<div class="page-template"><div class="header"><div class="logo"></div><div style="float: right">' +
            str.page +
            ' #: pageNum # ' +
            str.of +
            ' #: totalPages #</div>' +
            str.header +
            '</div><div class="footer"><div class="logo2"></div>' +
            str.footer +
            '</div></div>',
          scale: 0.5,
        },
        excel: {
          fileName: 'eigenkapitalforum_' + (new Date().getFullYear()) + '_stand_' + date + '.xlsx',
        },
        // sort: [{ field: 'company_name', dir: 'asc' }],
        sortable: true,
        height: 750,
        scrollable: {
          virtual: false,
        },
        columns: [
          {
            title: str.companies,
            field: 'company_name',
          },
          {
            title: str.isin,
            field: 'isin',
            template:
              '<div>#= data.isin || "-" #</div>',
          },
          {
            title: str.bbticker,
            field: 'bbticker',
            template:
              '<div>#= data.bbticker || "-" #</div>',
          },
          {
            title: str.market_cap,
            field: 'market_cap',
            template: function(data) {
              return '<div>' + kendo.htmlEncode(data.market_cap || "-").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '</div>';
            },
          },
          {
            title: str.index_member,
            field: 'index_member',
          },
          {
            title: str.stock_exchange,
            field: 'stock_exchange',
          },
          {
            title: str.category,
            field: 'category',
          },
          {
            title: str.date,
            field: 'start_time_string',
            template:
              '<div>#= data.start_time_string1 #</div><div><div>#= data.start_time_string2 #</div></div>',
            sortable: {
              compare: function(a, b) {
                if (a.pres_start_time < b.pres_start_time) {
                  return -1;
                }
                if (a.pres_start_time > b.pres_start_time) {
                  return 1;
                }
                return 0;
              },
            },
          },
          {
            title: str.room,
            field: 'speaker',
            template:
              '<div>#= data.room_name #</div><div><small style="font-size:11px">#= data.speaker #</small></div>',
          },
        ],
      };
      kendo.pdf.defineFont({
        'Helvetica_light': '/app/assets/fonts/5664085/2a34f1f8-d701-4949-b12d-133c1c2636eb.ttf',
        'Helvetica_roman': '/app/assets/fonts/5664093/08edde9d-c27b-4731-a27f-d6cd9b01cd06.ttf',
        'Helvetica_medium': '/app/assets/fonts/5664103/7802e576-2ffa-4f22-a409-534355fbea79.ttf'
      });
      this.loading = true;
      this.getData();
    });
  }

  generateStartTimeTemplate(item) {
    return '<span>' + item.weekDay + '</span>';
  }

  getData() {
    this.$timeout(() => {
      this.datatableService.getData(this.filter).then((result) => {
        this.gridOptions.data = result.data;
        this.loading = false;
        this.$scope.$apply();
      });
    }, 750);
  }

  getTableStyle() {
    var marginHeight = 20; // optional
    var length = this.options.data.length; // this is unique to my cellTemplate
    return {
      height:
        length * this.options.rowHeight +
        this.options.headerRowHeight +
        marginHeight +
        'px',
    };
  }

  getMarketCap(market_cap) {
    return market_cap;
  }
}

export default DatatableController;



// WEBPACK FOOTER //
// ./client/app/common/datatable/datatable.controller.js